import React from "react";
var __jsx = React.createElement;
import HeroSection from "@/pages/compare/sections/HeroSection";
import Layout from "@/_LayoutsRelated/layout/Layout";
import StepsSection from "@/pages/compare/sections/StepsSection";
import ComparisonImportanceSection from "@/pages/compare/sections/ComparisonImportanceSection";
import CompareConditionsSection from "@/pages/compare/sections/CompareConditionsSection";
var ComparePage = function ComparePage() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    authenticationMsg: true,
    mainClass: "aboutUs",
    linksForSearch: true,
    hasMobFooter: true
  }, /*#__PURE__*/React.createElement(HeroSection, null), /*#__PURE__*/React.createElement(StepsSection, null), /*#__PURE__*/React.createElement(ComparisonImportanceSection, null), /*#__PURE__*/React.createElement(CompareConditionsSection, null)));
};
export default ComparePage;